import React from "react";
import {Badge, CardBody, CardText, CardTitle} from "reactstrap";
import {FaEnvelope, FaPhoneAlt} from "react-icons/fa";

const ContactCard = ({data}) => {
  const {
    first_name = "",
    last_name = "",
    email = "",
    phone = "",
    is_primary = false,
  } = data;

  const full_name = `${first_name} ${last_name}`;
  return (
    <CardBody>
      <CardTitle tag="h3">
        <CardText>Name: {full_name}</CardText>{" "}
      </CardTitle>
      <Badge color="" className="badge-dot mr-4 ml-1">
        <CardTitle tag="h4">
          Primary
          {is_primary ? (
            <i className="bg-success" style={{marginLeft: "10%"}} />
          ) : (
            <i className="bg-warning" style={{marginLeft: "10%"}} />
          )}
        </CardTitle>
      </Badge>
      <div style={{display: "flex", alignItems: "baseline"}}>
        <span>
          <FaEnvelope aria-hidden="true" />
        </span>
        <CardText
          style={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            maxWidth: "25ch",
            marginLeft: "10px",
          }}
        >
          {email}
        </CardText>
      </div>
      <br />
      <CardText>
        <FaPhoneAlt aria-hidden="true" /> {phone}
      </CardText>
    </CardBody>
  );
};

export default ContactCard;
